import React from 'react';
import dateFormat from 'dateformat';
import { Typography } from '@mui/material';

export default function AdministrativeModification(props) {
  return (
    <React.Fragment>
      <div>
        <Typography variant='subtitle2' display='inline'>
          PERMITTEE:
        </Typography>
        <span>{` ${props.permit.PERMITTEE}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          WELL NOS.:
        </Typography>
        <span>{` ${props.permit.WELL_NOS}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          BOARD ACTION:
        </Typography>
        <span>{` ${dateFormat(
          props.permit.TARGET_END_DATE,
          'mmmm d, yyyy',
          true
        )}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          MODIFICATION:
        </Typography>
        <span>{` ${props.permit.MODIFICATIONS}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2'>RECOMMENDATIONS:</Typography>
        <span>{props.permit.RECOMMENDATIONS}</span>
      </div>
      <div>
        <Typography variant='subtitle2'>TESTIMONY AND FINDINGS:</Typography>
        <span>{props.permit.FINDINGS}</span>
      </div>
    </React.Fragment>
  );
}
